<template>
    <div class="teacherInfo">
        <div class="bottomBorder">
            <!--img :src="teacher.avatarURL" width="80px"
                 height="80px"
                 style="border-radius: 80px; float: left;margin-right:10px"
            /-->
            <div class="titleInfo primaryColor" style="font-weight: bold">
                Xin chào, {{student.fullName}}!
            </div>
            <div class="primaryColor">Đây là Trang lớp học Yoclass của bạn. Hãy tham gia lớp học ngay!</div>
            <!--div>
                {{teacher.countClass}} {{$t("lang.class.title")}}
            </div>
            <div>
                {{teacher.countStudent}} {{$t("lang.class.student")}}
            </div-->
        </div>
    </div>
</template>

<script>
    import {message} from '../../services';
    import IDatepicker from "../../components/form/DatePicker";
    import axios from "axios"
    import IUpload from "../../components/form/Upload";
    import {CrudService} from "@/services";

    export default {
        name: "student-info",
        components: {
            IUpload,
            IDatepicker,
        },

        data() {
            return {
                student: {}
            }
        },

        created() {
            if (this.$store.state.auth.user.userId) {
                CrudService.of('user').getItem(this.$store.state.auth.user.userId).then(user => {
                    //console.log(user);
                    this.student = user;
                    this.student.avatarURL = this.$store.state.auth.user.avatar;
                });

            }
        },

        methods: {}
    };
</script>
